import React, { useContext } from 'react'
import IntervenersList from './IntervenersList'
import IntervenerCards from './IntervenerCards'
import GlobalContext from '../GlobalContext'

export default function DeletedIntervenersTab ({ interveners }) {
  const { screens } = useContext(GlobalContext)

  return (
    <>
      { !screens.xs && <IntervenersList interveners={interveners} /> }
      { screens.xs && <IntervenerCards interveners={interveners} /> }
    </>
  )
}
